import { toast } from "react-toastify";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
} from "common/components/ui/Drawer";
import useLicenseMutations from "common/datahooks/useLicenseMutations";
import { HTTPError } from "common/helpers/HTTP";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { WorkspaceAccount } from "common/types";

interface AssignSeatModalProps {
  isOpen: boolean;
  account: WorkspaceAccount;
  onClose: () => void;
}

export default function AssignSeatModal({
  isOpen,
  account,
  onClose,
}: AssignSeatModalProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { assignLicense, isAssigningLicense } = useLicenseMutations();

  function assignLicenseToOwner() {
    assignLicense({ accountId: account.id })
      .then(onClose)
      .catch((error) => {
        toast.error(
          error instanceof HTTPError && error.serverMessage
            ? error.serverMessage
            : "Failed to assign seat",
        );
      });
  }

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <Component
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <Content className="lg:w-[448px]">
        <Title>Assign seat to {account.full_name}?</Title>

        <Description className="mb-8">
          You will get full access to LinkedIn Outreach and campaigns
        </Description>

        <div className="flex flex-col gap-y-2 lg:flex-row-reverse lg:gap-x-4">
          <Button
            size={isDesktop ? "md" : "lg"}
            className="flex-1"
            variant="gradient"
            onClick={assignLicenseToOwner}
            isLoading={isAssigningLicense}
          >
            Assign
          </Button>
          <Button
            variant="secondary-black"
            size={isDesktop ? "md" : "lg"}
            className="flex-1"
            disabled={isAssigningLicense}
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </Content>
    </Component>
  );
}
